import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import AppDrawer from "../AppDrawer";
import { Button } from "reactstrap";

interface Props {
  inline: boolean;
  record: Record<string, any>;
}

export default function WebsitePreviewDrawer({ inline, record }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isFirstRender = useRef(true);

  const website = searchParams?.get("w");

  // Everytime the reset state is updated, reload the iframe
  useEffect(() => {
    if (isFirstRender.current) {
      if (record && website) {
        isFirstRender.current = false;
      }
      return;
    }

    if (!iframeRef.current || !website) return;

    iframeRef.current?.contentWindow?.postMessage("refresh-page", "*");
  }, [record, website]);

  if (!website) return null;

  const finalWebsite = website.startsWith("http")
    ? website
    : `https://${website}`;

  const IFrame = (
    <div className="position-relative w-100 h-100">
      <iframe
        ref={iframeRef}
        className="iframe-show"
        id="gc-website-preview"
        title="GC Website Preview"
        src={`${finalWebsite}?iframe=true`}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          outline: "none",
        }}
      ></iframe>
      <Button
        color="danger"
        size="sm"
        className="position-absolute bottom-2 left-2"
        onClick={handleClose}
      >
        Close Preview
      </Button>
    </div>
  );

  if (inline) return IFrame;

  return (
    <AppDrawer
      open={true}
      onClose={handleClose}
      body={IFrame}
      headerTitle={"Website Preview"}
      disablePadding
      bodyCSS="px-0 pt-0 mt-0 mx-0 pb-5"
    />
  );

  function handleClose() {
    setSearchParams((params) => {
      params.delete("w");
      return params;
    });
  }
}
